<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      tag="div"
      :class="{ on: item.url == $route.fullPath }"
      v-for="(item, index) in footerList"
      :key="index"
      v-if="
        item.name != '团队'
          ? true
          : item.name == '团队' && teamStatus
          ? true
          : false
      "
    >
      <img :src="item.url == $route.fullPath ? item.icon2 : item.icon1" />
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
import { getTeamList } from "@/api/public";
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "推荐",
          icon1: require("../assets/images/icon_01.png"),
          icon2: require("../assets/images/icon_01_ac.png"),
          url: "/"
        },
        {
          name: "视频",
          icon1: require("../assets/images/icon_02.png"),
          icon2: require("../assets/images/icon_02_ac.png"),
          url: "/?index=1"
        },
        {
          name: "团队",
          icon1: require("../assets/images/icon_03.png"),
          icon2: require("../assets/images/icon_03_ac.png"),
          url: "/my/team"
        },
        {
          name: "客户",
          icon1: require("../assets/images/icon_04.png"),
          icon2: require("../assets/images/icon_04_ac.png"),
          url: "/kehu/index"
        },
        {
          name: "我的",
          icon1: require("../assets/images/icon_05.png"),
          icon2: require("../assets/images/icon_05_ac.png"),
          url: "/my"
        }
      ],
      teamStatus: false
    };
  },
  mounted() {
    console.log(this.$route);
    this.getTeamList();
  },
  methods: {
    /**
     * 获取团队列表
     */
    getTeamList() {
      getTeamList()
        .then(res => {
          this.teamStatus = true;
        })
        .catch(err => {
          if (err.data.msg == "数据不存在！") {
            this.teamStatus = false;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  position: relative;
  font-size: 0;
  img {
    width: 0.48rem;
    height: 0.48rem;
  }
  // &::after {
  //   position: absolute;
  //   content: "";
  //   width: 0.02rem;
  //   height: 0.5rem;
  //   background: #e5e5e5;
  //   right: 0;
  //   top: 50%;
  //   transform: translateY(-50%);
  // }
  // &:last-child::after {
  //   width: 0;
  // }
}
</style>
